/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _default = function _default(_ref) {
  var count = _ref.count,
      dragIndex = _ref.dragIndex,
      dropIndex = _ref.dropIndex,
      isRowReorderValid = _ref.isRowReorderValid;
  var validDropPositions = (0, _toConsumableArray2.default)(Array(count)).reduce(function (acc, curr, i) {
    acc[i] = true;
    return acc;
  }, {});
  validDropPositions[count] = true;

  if (isRowReorderValid) {
    validDropPositions[dropIndex] = isRowReorderValid({
      dragRowIndex: dragIndex,
      dropRowIndex: dropIndex
    });
  }

  return validDropPositions;
};

exports.default = _default;